import {sleep, useMock} from "../utils/helpers";
import http from "../plugins/http";
import config from '../config';

const uri = config.services.rating;

class Rates {
  constructor() {
    this.useMock = useMock('rates');
  }

  async fetchRates() {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(200);
        resolve((await import('../../mock/rates.js')));
      });
    }
  }

  async getRatesList(filter) {
    const params = {};
    params.limit = filter.limit || 25;
    params.page = filter.page || 1;

    const {data} = await http.get(`${uri}/api/v1/user/rates`, { params });

    return data.data;
  }

  async createRate(data) {
    // console.log(data);
    const res = await http.post(`${uri}/api/v1/rates`, data);

    return res.data;
  }

  async fetchRate(id, token) {
    const {data} = await http.get(`${uri}/api/v1/rates/${id}`);

    return data.data;
  }

  async getCurrentRateByAsset(assetId) {
    const {data} = await http.get(`${uri}/api/v1/user/rates/current/${assetId}`);
    return data.data;
  }

}

export default new Rates();



// WEBPACK FOOTER //
// ./src/services/rates.js